import { Button } from "@l30/ui";

interface ConversationRow {
  id: string;
  title: string;
}

interface AiHistoryRailProps {
  conversations: ConversationRow[];
  onSelect: (id: string) => void;
  onNewChat: () => void;
}

export function AiHistoryRail({ conversations, onSelect, onNewChat }: AiHistoryRailProps) {
  return (
    <aside className="flex w-full shrink-0 flex-col gap-2 rounded-soft-md border border-border bg-surface p-3 lg:w-56">
      <div className="flex items-center justify-between gap-2">
        <h2 className="text-sm font-medium text-fg">History</h2>
        <Button type="button" variant="ghost" size="sm" onClick={onNewChat}>
          New
        </Button>
      </div>
      <ul className="max-h-48 space-y-0.5 overflow-y-auto text-sm lg:max-h-none lg:flex-1">
        {conversations.map((c) => (
          <li key={c.id}>
            <button
              type="button"
              className="w-full truncate rounded-soft-md px-2 py-1.5 text-left text-fg hover:bg-muted"
              onClick={() => onSelect(c.id)}
            >
              {c.title || "Untitled"}
            </button>
          </li>
        ))}
        {conversations.length === 0 ? (
          <li className="px-2 text-xs text-muted-fg">No chats yet</li>
        ) : null}
      </ul>
    </aside>
  );
}
